export const getAvatarSrc = (avatar) => {
  if (typeof avatar === "string") {
    return avatar;
  } else if (avatar instanceof File || avatar instanceof Blob) {
    return URL.createObjectURL(avatar);
  }
  return "/images/avatar-default.png";
};
